import React from "react";

const Prepare = (
  <iframe 
    className="vid" 
    title="myFrame"
    src="https://www.youtube.com/embed/zWRKWkFF51w" 
    height={600} 
    width={1050}
    allowFullScreen
    webkitallowfullscreen="true"
    mozallowfullscreen="true"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share">
  </iframe>
);
const Webinar = (
  <iframe 
    className="vid" 
    title="webinar"
    src="https://www.youtube.com/embed/S_bPMp8X9Ug" 
    height={600} 
    width={1050}
    allowFullScreen
    webkitallowfullscreen="true"
    mozallowfullscreen="true"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share">
  </iframe>
);
const Demo = (
  <iframe 
    className="vid" 
    title="myFrame"
    src="https://www.youtube.com/embed/KEkBMLT-Edk" 
    height={600} 
    width={1050}
    allowFullScreen
    webkitallowfullscreen="true"
    mozallowfullscreen="true"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share">
  </iframe>
);
const Webinar2023 = (
  <iframe 
    className="vid" 
    title="myFrame"
    src="https://www.youtube.com/embed/O5jpaD8yFtc?si=bz8jDJGvV-Pu3Dtw" 
    height={600} 
    width={1050}
    allowFullScreen
    webkitallowfullscreen="true"
    mozallowfullscreen="true"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share">
  </iframe>
);
const EthicalScenarioWebinar = (
  <iframe 
    className="vid" 
    title="myFrame"
    src="https://www.youtube.com/embed/b93eO9Gc-v8?si=1QR6WwXnBUStLx85" 
    height={600} 
    width={1050}
    allowFullScreen
    webkitallowfullscreen="true"
    mozallowfullscreen="true"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share">
  </iframe>
);
const HotTopicsWebinar = (
  <iframe 
    className="vid" 
    title="myFrame"
    src="https://www.youtube.com/embed/Boos2b7mfEI?si=vFmc4RYy6MbYkO9J" 
    height={600} 
    width={1050}
    allowFullScreen
    webkitallowfullscreen="true"
    mozallowfullscreen="true"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share">
  </iframe>

);
const WeirdWebinar = (
  <iframe 
    className="vid" 
    title="myFrame"
    src="https://www.youtube.com/embed/AMPE7gvXRIE?si=FoNAMQdSzNVmLFQy" 
    height={600} 
    width={1050}
    allowFullScreen
    webkitallowfullscreen="true"
    mozallowfullscreen="true"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share">
  </iframe>
);

const posts = [
  {
    title: "How to Prepare for a Dental School Interview",
    id: 1,
    date: 1676905380,
    src: "/images/logged_out/auralyze_dental_thumbnail.webp",
    snippet:
      "A video guide on how to prepare for a dental school interview. This video is aimed at UK dental school interviews but the advice is applicable to all dental school interviews.",
    content: Prepare,
  },
  {
    title: "How to Ace Your Dental School Interview: Full Webinar",
    id: 2,
    date: 1677857496,
    src: 'https://www.cl-dental-school.co.uk/assets/images/parallax_images/school/school-768.webp',
    snippet:
      "A full webinar on  all things dental interview related. This webinar is aimed at UK dental school interviews but the advice is applicable to all dental school interviews.",
    content: Webinar,
  },
  {
    title: "How to Use Auralyze.ai to Smash Your Interviews",
    id: 3,
    date: 1692549454,
    src: "/images/logged_out/demo_video.png",
    snippet:
      "A video guide on how to use Auralyze.ai to smash your interviews. Everything you need to know about the platform and how to use it to your advantage.",
    content: Demo,
  },
  {
    title: "How to Write a Great Personal Statement Webinar 2023",
    id: 4,
    date: 1696410915,
    src: "/images/logged_out/webinar.png",
    snippet: "Our inagural webinar of our new series for the 2024 admissions cycle, this webinar is aimed at UK dental school personal statements, but the advice is applicable to Medicine and general STEM personal statements.",
    content: Webinar2023,
  },
  {
    title: "Ethical Scenario Webinar",
    id: 5,
    date: 1696410915,
    src: "/images/logged_out/ethicalWebinar.png",
    snippet: "Our second webinar of our new series for the 2024 admissions cycle, this webinar helps medical and dental school applicants tackle ethical scenarios.",
    content: EthicalScenarioWebinar,
  },
  {
    title: "Hot Topics Webinar",
    id: 6,
    date: 1696410915,
    src: "/images/logged_out/HotTopics.png",
    snippet: "Our third webinar of our new series for the 2024 admissions cycle, this webinar helps medical and dental school applicants tackle hot topics.",
    content: HotTopicsWebinar,
  },
  {
    title: "Personality and Weird Questions Webinar",
    id: 7,
    date: 1696410915,
    src: "/images/logged_out/WeirdQuestions.png",
    snippet: "Our fourth webinar of our new series for the 2024 admissions cycle, this webinar helps medical and dental school applicants tackle weird questions.",
    content: WeirdWebinar,
  },
];

export default posts;